import type { ReactNode } from "react";
import { Compass } from "react-feather";

// Shared "nothing here" state — used by the route-level 404 page and by detail
// screens whose record id doesn't resolve (recipe/collection not found). Callers
// supply the copy and the recovery actions so each context points somewhere useful.
export function NotFoundView({
  code,
  icon,
  title,
  message,
  actions,
}: {
  code?: string;
  icon?: ReactNode;
  title: string;
  message: string;
  actions?: ReactNode;
}) {
  return (
    <div className="max-w-5xl mx-auto">
      <div className="flex flex-col items-center text-center py-16 sm:py-24">
        <div className="w-16 h-16 rounded-2xl bg-terracotta-wash flex items-center justify-center mb-6">
          {icon ?? <Compass className="w-8 h-8 text-terracotta" />}
        </div>
        {code && (
          <p className="font-display text-6xl font-extrabold text-ink leading-none mb-3">
            {code}
          </p>
        )}
        <h1 className="font-display text-2xl font-bold text-ink mb-2">{title}</h1>
        <p className="text-ink-soft max-w-md mb-8">{message}</p>
        {actions && (
          <div className="flex flex-wrap items-center justify-center gap-3">{actions}</div>
        )}
      </div>
    </div>
  );
}
